import React from 'react';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, message, Upload } from 'antd';
import type { AdminProductStockControlProps } from '../../interfaces';
import { filterValidImageFiles, rejectInvalidImageUpload } from '../../../utils/uploadValidation';

type AdminProductMaterialImagesProps = Pick<
  AdminProductStockControlProps,
  'material' | 'productId' | 'onUploadMaterialImages' | 'onDeleteMaterialImage'
>;

const AdminProductMaterialImages: React.FC<AdminProductMaterialImagesProps> = ({
  material,
  productId,
  onUploadMaterialImages,
  onDeleteMaterialImage,
}) => (
  <label className="admin-product-form__stock-field">
    <span>Images</span>
    <Upload
      multiple
      showUploadList={false}
      accept="image/jpeg,image/png,image/webp"
      beforeUpload={(file, fileList) => {
        if (file.uid === fileList[0]?.uid) {
          const validFiles = filterValidImageFiles(fileList);

          if (validFiles.length) {
            void onUploadMaterialImages(productId, material.id, validFiles);
          }
        }

        return rejectInvalidImageUpload(file);
      }}
    >
      <Button icon={<UploadOutlined />}>Upload Images</Button>
    </Upload>
    {!!material.productImages?.length && (
      <div className="admin-product-form__material-image-list">
        {material.productImages.map((productImage) => (
          <div key={productImage.id} className="admin-product-form__material-image-item">
            {productImage.image?.publicUrl && (
              <img src={productImage.image.publicUrl} alt={`${material.materialName} preview`} />
            )}
            <Button
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => {
                if ((material.productImages?.length || 0) <= 1) {
                  message.error('Material requires at least one image.');
                  return;
                }

                void onDeleteMaterialImage(productImage.id);
              }}
            />
          </div>
        ))}
      </div>
    )}
  </label>
);

export default AdminProductMaterialImages;
